import React, { useEffect, useRef, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './termsPopup.scss';
import { useFormikContext } from 'formik';
import { publicDomainUrl } from '../../utils/config';

interface TermsPopupProps {
  open: boolean;
  onClose: () => void;
  url: string;
  title?: string;
}

export const TermsPopup: React.FC<TermsPopupProps> = ({ 
  open, onClose, url, title = "Terms of Use" 
}) => {
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      className="terms-popup-dialog"
    >
      <DialogTitle className="terms-popup-title">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <span>{title}</span>
          <IconButton
            onClick={onClose}
            size="small"
            className="close-button"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent className="terms-popup-content">
        <Iframe url={url} title={title} open={open} onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
};

const Iframe = ({ url, title, open, onClose }: { url: string, title: string, open: boolean, onClose: () => void }) => {
  const iframeRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        sendMessage();
        setLoading(false);
      }, 2000);
    }
  }, [open])
  const formikContext = useFormikContext<any>();

  const sendMessage = () => {
    const iframe = iframeRef.current as HTMLIFrameElement | null;
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage(
        {
          msg: "SIGNUP_EVENT",
          termsAccepted: (formikContext?.values?.termsOfUse || false),
          privacyAccepted: (formikContext?.values?.privacy || false),
          salesAgreementAccepted: (formikContext?.values?.salesAgreement || false)
        },
        publicDomainUrl
      );
    }
  };

  
    useEffect(() => {
      const handleMessage = (event: any) => {
        if (event.origin !== publicDomainUrl) {
          return;
        }
        onClose();
        if (event.data.msg === 'TERMS_OF_USE_ACCEPTED') {
          const values = formikContext?.values || {};
          formikContext?.setValues({
            ...values,
            termsOfUse: event?.data?.termsAccepted
          })
        }
        if (event.data.msg === 'PRIVACY_POLICY_ACCEPTED') {
          const values = formikContext?.values || {};
          formikContext?.setValues({
            ...values,
            privacy: event?.data?.privacyAccepted
          })
        }
        if (event.data.msg === 'SALES_AGREEMENT_ACCEPTED') {
          const values = formikContext?.values || {};
          formikContext?.setValues({
            ...values,
            salesAgreement: event?.data?.salesAgreementAccepted
          })
        }
      };
  
      window.addEventListener("message", handleMessage);
      return () => {
        window.removeEventListener("message", handleMessage);
      };
    }, [formikContext]);

  return (
    <>
      {loading &&
      <div className="terms-of-use-loading">
        <CircularProgress size={28} />
      </div>}
      <iframe
        ref={iframeRef}
        src={url}
        width="100%"
        title={title}
        className="terms-iframe"
      />
    </>
  )
}